import React from "react";
import NewsletterFour from "../component/NewsletterFour";

function NewsletterFourContainers() {
  return <NewsletterFour />;
}

export default NewsletterFourContainers;
